<template>
  <div
    class="aiz-mobile-bottom-nav d-xl-none fixed-bottom bg-white shadow-lg border-top rounded-top"
    style="
      box-shadow: 0 -1px 10px rgb(0 0 0 / 15%) !important;
      min-height: 80px;
    "
  >
    <div class="row align-items-center gutters-5" style="min-height: 80px">
      <div class="col">
        <router-link
          class="text-reset d-block text-center pb-2 pt-3"
          style="min-height: 80px"
          to="/"
        >
          <i class="las la-home fs-20 opacity-60"></i>
          <span class="d-block fs-10 fw-600 opacity-60">{{ $t("首页") }}</span>
        </router-link>
      </div>
      <div class="col">
        <router-link
          class="text-reset d-block text-center pb-2 pt-3"
          style="min-height: 80px"
          to="/categories"
        >
          <i class="las la-list-ul fs-20 opacity-60"></i>
          <span class="d-block fs-10 fw-600 opacity-60">{{ $t("类别") }}</span>
        </router-link>
      </div>
      <div class="col" @click="paramMapAll['SYSTEM_VERSION']!=='L280' ?goto('/user/cart'):goto('/user/taskOrder')">
        <a
          class="text-reset text-center pb-2 pt-3"
          style="min-height: 80px;display: flex;flex-direction: column;justify-content: center;align-items: center;"
        >
          <span
            class="align-items-center bg-primary border border-white border-width-4 d-flex justify-content-center position-relative rounded-circle size-50px"
            style="
              margin-top: -33px;
              box-shadow: 0 -5px 10px rgb(0 0 0 / 15%);
              border-color: #fff !important;
            "
          >
            <i class="las la-shopping-bag la-2x text-white"></i>
          </span>
          <span  class="d-block mt-1 fs-10 fw-600 opacity-60">
            <div v-if="paramMapAll['SYSTEM_VERSION']!=='L280'">
                          {{ $t("购物车") }} (<span class="cart-count">{{ userCartItemCount }}</span
            >)
            </div>
            <div v-else>{{ $t("任务") }}</div>

          </span>
        </a>
      </div>
      <div class="col" v-if="paramMapAll['MENU_NOTICE_OPEN']===undefined || paramMapAll['MENU_NOTICE_OPEN'] === '1'">
        <a
          class="text-reset d-block text-center pb-2 pt-3"
          style="min-height: 80px"
          @click="onClickNotifications"
        >
          <span class="d-inline-block position-relative px-2">
            <i class="las la-bell fs-20 opacity-60"></i>
          </span>
          <span class="d-block fs-10 fw-600 opacity-60">{{ $t("通知") }}</span>
        </a>
      </div>
      <div class="col" @click="paramMapAll['SYSTEM_VERSION']!=='L280' ?goto('/user/wallet'):goto('/user/assist')">
        <a
          class="text-reset d-block text-center pb-2 pt-3"
          style="min-height: 80px"
        >
          <span class="d-inline-block position-relative px-2">
            <i class="las la-dollar-sign fs-20 opacity-60"></i>
          </span>
          <span class="d-block fs-10 fw-600 opacity-60">{{ paramMapAll['SYSTEM_VERSION']!=='L280'?$t("我的钱包"):$t("商家助力") }}</span>
        </a>
      </div>
      <div class="col">
        <a
          class="text-reset d-block text-center pb-2 pt-3"
          href="javascript:void(0)"
          style="min-height: 80px"
          @click="onClickAccount"
        >
          <span class="d-block mx-auto">
            <img
              alt=""
              class="rounded-circle size-20px"
              src="/static/assets/img/avatar-place.png"
            />
          </span>
          <span class="d-block fs-10 fw-600 opacity-60">{{ $t("账户") }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { isLogin } from "@/utils/auth";

export default {
  methods: {
    onClickNotifications() {
      if (isLogin()) {
        this.goto("/user/all-notifications");
      } else {
        this.goto("/login");
      }
    },
    onClickAccount() {
      if (isLogin()) {
        this.$store.commit("common/SET_accountPanelShow", true);
      } else {
        this.goto("/login");
      }
    }
  }
};
</script>
